import { FC } from "react";
import Container from "~/components/Container";
import TabReviews from "~/components/TabReviews";

interface SectionTabReviewsProps {}

const SectionTabReviews: FC<SectionTabReviewsProps> = () => {
  return (
    <Container>
      <TabReviews />
    </Container>
  );
};

export default SectionTabReviews;
